import ScoreMeter from './ScoreMeter';
import './score-meter.scss';

export default ScoreMeter;
